<template>
  <img alt="Vue logo" src="./assets/logo.png">
  <TempJoker msg="TempJoker" />
  <HelloWorld msg="Welcome to Your Vue.js App" style="display: none;" />
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import TempJoker from './components/TempJoker.vue'

export default {
  name: 'App',
  components: {
    HelloWorld,
    TempJoker
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
